import React from 'react';

interface Props {
  channelUrl: string;
  otherProfileId: string;
  authenticityToken?: string;
}

const SendJobButton: React.FC<Props> = ({ channelUrl, otherProfileId, authenticityToken }) => {
  const [open, setOpen] = React.useState(false);

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setOpen(true);
  };

  return (
    <>
      <button
        type="button"
        className="dd-chat__share-btn"
        onClick={onClick}
        title="Share a job in this conversation"
      >
        <i className="fas fa-briefcase" /> Share Job
      </button>

      {/* JobSelectorModal will be dynamically imported by parent when open */}
      {open && (
        // dynamically require to avoid increasing initial bundle size for non-users
        React.createElement(require('./JobSelectorModal').default, {
          channelUrl,
          recipientProfileUuid: otherProfileId,
          onClose: () => setOpen(false),
          authenticityToken
        })
      )}
    </>
  );
};

export default SendJobButton;


